var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal2fa-popup" },
    [
      _c(
        "confirmationDialog",
        {
          attrs: {
            dialogStatus: _vm.dialogStatus,
            title: "Reset 2FA",
            eventName: "twoFaEvent",
            actions: !_vm.validateOldCode
              ? _vm.validateCodeActions
              : _vm.twoFaCodeActions
          },
          on: { twoFaEvent: _vm.twoFaActions }
        },
        [
          _c("v-container", { staticClass: "pa-0" }, [
            _c("div", { staticClass: "resetpage-content" }, [
              _vm.validateOldCode
                ? _c("div", [
                    _c("div", { staticClass: "qrcode__container" }, [
                      _c("div", [
                        _c("p", [
                          _vm._v(
                            "You will need a 2FA method for security. Please download and install any authenticator app on your phone. If it is already installed, you can skip this screen!"
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "1.Download and install an app (such as Google Authenticator) on your mobile."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "2. Open the authenticator and scan the QR code."
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "qr-code",
                      domProps: { innerHTML: _vm._s(_vm.htmlCode) }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "3. Enter the 6-digit verification code generated."
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-element customized-textfield" },
                [
                  _c("label", { staticClass: "pl-1" }, [
                    _vm._v("Factor authentication code")
                  ]),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Enter 2-factor authentication code",
                      solo: "",
                      flat: "",
                      "background-color": "#F7F7F7",
                      color: "#E34E25",
                      "append-icon": _vm.otpCode ? "clear" : "",
                      "error-messages": this.invalidOTP
                        ? "Invalid verification code"
                        : ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.otpCode = ""
                      }
                    },
                    model: {
                      value: _vm.otpCode,
                      callback: function($$v) {
                        _vm.otpCode = $$v
                      },
                      expression: "otpCode"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }